// src/layouts/MainLayout.js
import Header from "../Header";
import Footer from "../Footer";
import ScrollToTop from "../component/Helper";
import BackgroundUpdater from "../component/Setbackground";
import { Outlet } from "react-router-dom";

const MainLayout = () => {
  return (
    <>
      <ScrollToTop />
      <BackgroundUpdater />
      <Header />
      <Outlet />
      <Footer />
    </>
  );
};

export default MainLayout;
